import ConfigurationManager from "../../settings/ConfigurationManager";
import { removeZerosSinGuion } from "../../utils/helpers.js";
import { isMobile } from 'react-device-detect';
import Encryptor from "../../utils/Encryptor.js";

async function SendRequest(endpoint, body) {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const response = await fetch(`${ConfigurationManager.API_URL}/${endpoint}`, {
            method: "POST",
            headers: myHeaders,
            body: body
        });

        const json = await response.json();
        if (!response.ok) {
            console.error(response);
        }

        return json;
    } catch (error) {
        console.error(error);
    } finally {

    }
}

export async function checkUpdateTime(rut) {
    try {
        const response = await SendRequest(
            "VerificaTiempoActualizacion",
            JSON.stringify({
                "rut": rut
            })
        );

        return response;

    } catch (error) {
        console.error('Error during request: checkUpdateTime', error);
        return null; // Return null or handle the error as needed
    }
}

export async function requestCode(data, step = 'phone') {
    try {
        const baseUrl = `${window.location.origin}/pin/code/${data.id}/${step}`;
        
        if (step === 'phone' && data.updatePhone) {
            // Enviar teléfono sin el primer 9 (8 dígitos)
            const phoneToSend = data.phone && data.phone.length === 9 && data.phone.startsWith('9') 
                ? data.phone.substring(1) 
                : data.phone;
            
            const response = await SendRequest(
                "SolictaActualizarDatosContacto",
                JSON.stringify({
                    "rut": data.rut,
                    "fono": phoneToSend,
                    "mail": "",
                    "url": baseUrl
                })
            );
            return response;
        }

        if (step === 'email' && data.updateMail) {
            const response = await SendRequest(
                "SolictaActualizarDatosContacto",
                JSON.stringify({
                    "rut": data.rut,
                    "fono": "",
                    "mail": data.email,
                    "url": baseUrl
                })
            );
            return response;
        }

        return { resultado: { codigo: "ERROR", mensaje: "No se pudo enviar el código" } };

    } catch (error) {
        console.error('Error during request: requestCode', error);
        return null;
    }
}

export async function confirmacionEmail(urlCallback, pin) {
    try {
        const response = await SendRequest(
            "ConfirmacionActualizarDatosContactoMAIL",
            JSON.stringify({
                "Url": urlCallback,
                "Pin": pin
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: confirmacionEmail', error);
        return null; // Return null or handle the error as needed
    }
}

export async function confirmacionSMS(urlCallback, pin) {
    try {
        const response = await SendRequest(
            "ConfirmacionActualizarDatosContactoSMS",
            JSON.stringify({
                "Url": urlCallback,
                "Pin": pin
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: confirmacionSMS', error);
        return null; // Return null or handle the error as needed
    }
}

// Autentica con clave sacu
export async function authenticated(IdePer, ClaveWeb) {
    try {
        const response = await SendRequest(
            "Autenticar",
            JSON.stringify({
                "IdePer": IdePer,
                "ClaveWeb": ClaveWeb
            })
        );
        return response;
    } catch (error) {
        console.error('Error during request: authenticated', error);
        return false;
    } finally {

    }
}

// Verifica si el afiliado esta enrolado en el proceso de biometria
export async function isEnrolled(user, encondeData) {
    try {
        const response = await SendRequest(
            "Biometria",
            JSON.stringify({
                "FlowId": "66db107213807bf6b7a256bf",
                "User": removeZerosSinGuion(user),
                "CallbackOk": `${window.location.origin}/pin/update-info/${encondeData}`,
                "CallbackNok": `${window.location.origin}/pin/qr-enroll/notok`
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: isEnrolled', error);
        return false;
    } finally {

    }
}

// Comienza el proceso de biometria
export async function startEnrolled(user, encodeData) {
    const crypto = new Encryptor();
    try {
        const encrypted = crypto.encrypt(encodeData);
        const callbackOkUrl = isMobile ? `${window.location.origin}/pin/update-info/${encrypted}` : "";
        const callbackNokUrl = isMobile ? `${window.location.origin}/pin/qr-enroll/notok` : "";

        const response = await SendRequest(
            "Biometria",
            JSON.stringify({
                "FlowId": "6a0631435db3d92bb5bb6572",
                "User": removeZerosSinGuion(user),
                "CallbackOk": callbackOkUrl,
                "CallbackNok": callbackNokUrl
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: startEnrolled', error);
        return false;
    } finally {

    }
}

// Entrega el estado del proceso de biometria
export async function getStatus(instance, token) {
    try {
        const response = await SendRequest(
            "ObtenerEstado",
            JSON.stringify({
                "instance": instance,
                "token": token
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: getStatus', error);
        return false;
    } finally {

    }
}

export async function fetchPersonalData(rut) {
    try {
        const response = await SendRequest(
            "TraerDatosPersonales",
            JSON.stringify({
                "IdePer": rut
            })
        );

        return response;
    } catch (error) {
        console.error('Error during request: fetchPersonalData ', error);
        return false;
    } finally {

    }
}

export async function modificarDatosPersonales(request) {
    try {
        console.log('modificarDatosPersonales - Request recibido:', request);
        console.log('modificarDatosPersonales - email original:', request.email);
        
        // Siempre enviar email (vacío si no hay)
        const emailToSend = request.email ? request.email : "";
        
        const payload = {
            "IdePer": request.rut,
            "celular": request.phone,
            "email": emailToSend
        };
        
        console.log('modificarDatosPersonales - Payload a enviar:', payload);
        console.log('modificarDatosPersonales - Email final enviado:', `"${payload.email}"`);
        console.log('modificarDatosPersonales - ¿Email está vacío?', payload.email === "");
        
        const response = await SendRequest(
            "ModificarDatosPersonales",
            JSON.stringify(payload)
        );

        console.log('modificarDatosPersonales - Respuesta:', response);
        return response;
    } catch (error) {
        console.error('Error during request: modificarDatosPersonales', error);
        return false;
    } finally {

    }
}

export async function UrlSave(request) {
    try {
        const response = await SendRequest(
            "url/save",
            JSON.stringify({
                "rut": request.rut,
                "phone": request.phone,
                "hasEmail": true,
                "email": request.email,
                "repitEmail": request.repitEmail,
                "password": "",
                "isEnrolled": request.isEnrolled,
                "link": request.link,
                "image": request.image,
                "updateMail": request.updateMail,
                "updatePhone": request.updatePhone,
            }));

        return response;
    } catch (error) {
        console.error('Error during request: modificarDatosPersonales', error);
        return false;
    } finally {

    }
}

export async function UrlGet(id) {
    try {
        const response = await SendRequest(`url/get/${id}`);

        return response;
    } catch (error) {
        console.error('Error during request: modificarDatosPersonales', error);
        return false;
    } finally {

    }
}

export async function UrlDelete(id) {
    try {
        const response = await SendRequest(`url/delete/${id}`);

        return response;
    } catch (error) {
        console.error('Error during request: modificarDatosPersonales', error);
        return false;
    } finally {

    }
}

export async function UrlUpdate(request) {
    try {
        console.log('UrlUpdate - Request recibido:', request);
        
        const payload = {
            "id": request.id,
            "rut": request.rut,
            "phone": request.phone,
            "hasEmail": true,
            "email": request.email,
            "repitEmail": request.repitEmail,
            "password": request.password || "",
            "isEnrolled": request.isEnrolled || false,
            "link": request.link || "",
            "image": request.image || "",
            "updateMail": request.updateMail || false,
            "updatePhone": request.updatePhone || false,
        };
        
        console.log('UrlUpdate - Payload a enviar:', payload);
        console.log('UrlUpdate - ID en payload:', payload.id);
        
        const response = await SendRequest(
            "url/update",
            JSON.stringify(payload)
        );

        console.log('UrlUpdate - Respuesta del backend:', response);
        return response;
    } catch (error) {
        console.error('Error during request: UrlUpdate', error);
        return false;
    } finally {

    }
}

export async function UpdatePhone(id, active) {
    try {
        const response = await SendRequest(`url/update/phone/${id}/${active}`);

        return response;
    } catch (error) {
        console.error('Error during request: UpdatePhone', error);
        return false;
    } finally {

    }
}

export async function UpdateEmail(id, active) {
    try {
        const response = await SendRequest(`url/update/email/${id}/${active}`);

        return response;
    } catch (error) {
        console.error('Error during request: UpdateEmail', error);
        return false;
    } finally {

    }
}